import { render, staticRenderFns } from "./DailyProductsCustomersbyRo.vue?vue&type=template&id=1b3cd14b"
import script from "./DailyProductsCustomersbyRo.vue?vue&type=script&lang=js"
export * from "./DailyProductsCustomersbyRo.vue?vue&type=script&lang=js"
import style0 from "./DailyProductsCustomersbyRo.vue?vue&type=style&index=0&id=1b3cd14b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports